var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-auth" }, [
    _c(
      "div",
      { staticClass: "checkout-auth-info" },
      [
        _c("f-sprite-icon", {
          attrs: { "icon-link": _vm.$options.icons.ClubCard.id }
        }),
        _vm._v(
          "\n    Используйте бонусы Клубной программы и получайте дополнительные скидки\n  "
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "checkout-auth-buttons" },
      [
        _c("ui-button", {
          attrs: { text: "Войти и использовать бонусы" },
          on: { click: _vm.login }
        }),
        _c("ui-button", {
          attrs: { secondary: "", text: "Зарегистрироваться" },
          on: { click: _vm.login }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }